import classNames from 'classnames';
import type { ReactNode } from 'react';

import styles from './BrowserWindow.module.scss';

interface Props {
    children?: ReactNode;
    className?: string;
}

export function BrowserWindow({ children, className }: Props) {
    return (
        <div className={classNames(styles.window, className)}>
            <div className={styles.toolbar}>
                <div className={styles.buttons}>
                    <span className={styles.dot} />
                    <span className={styles.dot} />
                    <span className={styles.dot} />
                </div>
            </div>

            <div className={styles.content}>{children}</div>
        </div>
    );
}
